import { render, staticRenderFns } from "./HistoryControls.vue?vue&type=template&id=8d324078&"
import script from "./HistoryControls.vue?vue&type=script&lang=ts&"
export * from "./HistoryControls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports